import React from "react";

import {
  Drawer,
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography
} from "@mui/material";

import HomeIcon from "@mui/icons-material/Home";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import DashboardIcon from "@mui/icons-material/Dashboard";
import FeedbackIcon from "@mui/icons-material/Feedback";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import ChecklistIcon from "@mui/icons-material/Checklist";

const HEADER_HEIGHT = 72;

const SideMenu = ({
  open,
  toggleDrawer,
  navigate,
  user,
  onLogout
}) => {

  const menuItemStyle = {
    borderRadius: "14px",
    mx: 1.2,
    my: 0.3,
    py: 1.2,
    px: 1,

    transition: "all 0.25s ease",

    "& .MuiListItemIcon-root": {
      color: "#fff",
      minWidth: 42
    },

    "& .MuiListItemText-primary": {
      color: "#fff",
      fontWeight: 600,
      fontSize: "0.96rem"
    },

    "&:hover": {
      background:
        "rgba(255,255,255,0.10)",

      transform:
        "translateX(4px)"
    }
  };

  const handleNavigate = (path) => {
    navigate(path);
    toggleDrawer();
  };

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={toggleDrawer}
      ModalProps={{
        keepMounted: true
      }}
      sx={{
        zIndex: 1400
      }}
      PaperProps={{
        sx: {
          width: 300,

          mt: `${HEADER_HEIGHT}px`,

          height:
            `calc(100vh - ${HEADER_HEIGHT}px)`,

          background:
            "linear-gradient(180deg,#630000 0%, #8B0000 100%)",

          color: "#fff",

          overflow: "hidden",

          borderTopRightRadius: "26px",

          borderBottomRightRadius:
            "26px",

          boxShadow:
            "0 18px 40px rgba(0,0,0,0.28)",

          display: "flex",

          flexDirection: "column"
        }
      }}
    >
      {/* TOP BRAND */}
      <Box
        sx={{
          px: 3,
          py: 2.5,

          borderBottom:
            "1px solid rgba(255,255,255,0.08)"
        }}
      >
        <Typography
          sx={{
            fontSize: "1.45rem",
            fontWeight: 800,
            color: "#fff"
          }}
        >
          SwadVeda Masale
        </Typography>

        <Typography
          sx={{
            fontSize: "0.82rem",
            color:
              "rgba(255,255,255,0.72)"
          }}
        >
          Pure Desi Taste
        </Typography>
      </Box>

      {/* SCROLLABLE CONTENT */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",

          "&::-webkit-scrollbar": {
            width: "6px"
          },

          "&::-webkit-scrollbar-thumb": {
            background:
              "rgba(255,255,255,0.22)",
            borderRadius: "10px"
          }
        }}
      >
        <List sx={{ py: 1.5 }}>

          <ListItemButton
            onClick={() =>
              handleNavigate("/")
            }
            sx={menuItemStyle}
          >
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>

            <ListItemText primary="Home" />
          </ListItemButton>

          <ListItemButton
            onClick={() =>
              handleNavigate("/cart")
            }
            sx={menuItemStyle}
          >
            <ListItemIcon>
              <ShoppingCartIcon />
            </ListItemIcon>

            <ListItemText primary="Cart" />
          </ListItemButton>

          {user && (
            <>
              <Divider
                sx={{
                  borderColor:
                    "rgba(255,255,255,0.08)",
                  my: 1.5
                }}
              />

              <ListItemButton
                onClick={() =>
                  handleNavigate("/profile")
                }
                sx={menuItemStyle}
              >
                <ListItemIcon>
                  <AccountCircleIcon />
                </ListItemIcon>

                <ListItemText primary="Profile" />
              </ListItemButton>

              <ListItemButton
                onClick={() =>
                  handleNavigate("/wallet")
                }
                sx={menuItemStyle}
              >
                <ListItemIcon>
                  <AccountBalanceWalletIcon />
                </ListItemIcon>

                <ListItemText primary="Wallet & Referral" />
              </ListItemButton>

              <ListItemButton
                onClick={() =>
                  handleNavigate("/my-orders")
                }
                sx={menuItemStyle}
              >
                <ListItemIcon>
                  <ShoppingCartIcon />
                </ListItemIcon>

                <ListItemText primary="My Orders" />
              </ListItemButton>

              {user?.role === "admin" && (
                <>
                  <Divider
                    sx={{
                      borderColor:
                        "rgba(255,255,255,0.08)",
                      my: 2
                    }}
                  />

                  <Typography
                    sx={{
                      px: 3,
                      pb: 1,
                      pt: 0.5,

                      color:
                        "rgba(255,255,255,0.58)",

                      fontSize: "0.78rem",

                      fontWeight: 700,

                      letterSpacing: 1.4,

                      textTransform:
                        "uppercase"
                    }}
                  >
                    Admin Panel
                  </Typography>

                  <ListItemButton
                    onClick={() =>
                      handleNavigate(
                        "/admin/products"
                      )
                    }
                    sx={menuItemStyle}
                  >
                    <ListItemIcon>
                      <DashboardIcon />
                    </ListItemIcon>

                    <ListItemText primary="Manage Products" />
                  </ListItemButton>

                  <ListItemButton
                    onClick={() =>
                      handleNavigate(
                        "/admin/orders"
                      )
                    }
                    sx={menuItemStyle}
                  >
                    <ListItemIcon>
                      <DashboardIcon />
                    </ListItemIcon>

                    <ListItemText primary="Manage Orders" />
                  </ListItemButton>

                  <ListItemButton
                    onClick={() =>
                      handleNavigate(
                        "/admin/feedback"
                      )
                    }
                    sx={menuItemStyle}
                  >
                    <ListItemIcon>
                      <FeedbackIcon />
                    </ListItemIcon>

                    <ListItemText primary="Feedback & Complaints" />
                  </ListItemButton>

                  <ListItemButton
                    onClick={() =>
                      handleNavigate(
                        "/admin/wallet"
                      )
                    }
                    sx={menuItemStyle}
                  >
                    <ListItemIcon>
                      <AccountBalanceWalletIcon />
                    </ListItemIcon>

                    <ListItemText primary="Manage Wallets" />
                  </ListItemButton>

                  <ListItemButton
                    onClick={() =>
                      handleNavigate(
                        "/admin/inventory"
                      )
                    }
                    sx={menuItemStyle}
                  >
                    <ListItemIcon>
                      <Inventory2Icon />
                    </ListItemIcon>

                    <ListItemText primary="Manage Inventory" />
                  </ListItemButton>
                  <ListItemButton
  onClick={() =>
    handleNavigate(
      "/admin/tasks"
    )
  }
  sx={menuItemStyle}
>
  <ListItemIcon>
    <ChecklistIcon />
  </ListItemIcon>

  <ListItemText primary="Task Management" />
</ListItemButton>
                </>
              )}

              <Divider
                sx={{
                  borderColor:
                    "rgba(255,255,255,0.08)",
                  my: 2
                }}
              />

              <ListItemButton
                onClick={() => {
                  toggleDrawer();
                  onLogout();
                }}
                sx={{
                  ...menuItemStyle,

                  background:
                    "rgba(255,255,255,0.06)"
                }}
              >
                <ListItemIcon>
                  <LogoutIcon />
                </ListItemIcon>

                <ListItemText primary="Logout" />
              </ListItemButton>
            </>
          )}
        </List>
      </Box>

      {/* FOOTER */}
      <Box
        sx={{
          p: 2,
          textAlign: "center",

          borderTop:
            "1px solid rgba(255,255,255,0.08)"
        }}
      >
        <Typography
          sx={{
            color:
              "rgba(255,255,255,0.6)",

            fontSize: "0.75rem"
          }}
        >
          © {new Date().getFullYear()} SwadVeda
        </Typography>
      </Box>
    </Drawer>
  );
};

export default SideMenu;